import { styled } from '@mui/material/styles'

const AppWrapper = styled('div')`
  display: flex;
  padding-top: 65px;
`

export { AppWrapper }
